document.addEventListener('DOMContentLoaded', () => {
    // Select all the accordion headers
    const accordionHeaders = document.querySelectorAll('.faq-dropdown-section__accordion-item-header');
  
    accordionHeaders.forEach(header => {
      header.addEventListener('click', () => {
        // Get the accordion content element within the same parent
        const content = header.parentElement.querySelector('.faq-dropdown-section__accordion-item-content');
  
        // Check if the clicked header is already active/open
        if (header.classList.contains('active')) {
          closeAccordion(header, content);
        } else {
          // Optionally, close any other open accordions if you want only one open at a time.
          const activeHeaders = document.querySelectorAll('.faq-dropdown-section__accordion-item-header.active');
          activeHeaders.forEach(activeHeader => {
            const activeContent = activeHeader.parentElement.querySelector('.faq-dropdown-section__accordion-item-content');
            closeAccordion(activeHeader, activeContent);
          });
  
          openAccordion(header, content);
        }
      });
    });
  });
  
  function openAccordion(header, content) {
    header.classList.add('active');
    // Set the height to the scrollHeight to animate opening
    content.style.height = content.scrollHeight + 'px';
    content.classList.add('active');
  
    // When the transition ends, remove the inline height if open so it can adapt if content changes.
    content.addEventListener('transitionend', function handler(e) {
      if (e.propertyName === 'height' && header.classList.contains('active')) {
        content.style.height = 'auto';
      }
      content.removeEventListener('transitionend', handler);
    });
  }
  
  function closeAccordion(header, content) {
    header.classList.remove('active');
    content.classList.remove('active');

    // For a smooth close, if the height is 'auto' we first set it to the current pixel height.
    if (content.style.height === 'auto') {
      content.style.height = content.scrollHeight + 'px';
      // Force reflow to apply the new fixed height
      content.offsetHeight;
    }
    // Then animate to 0
    content.style.height = '0px';
  }
  